import { render } from "./InterestSelection.vue?vue&type=template&id=3b02eee0"
import script from "./InterestSelection.vue?vue&type=script&lang=js"
export * from "./InterestSelection.vue?vue&type=script&lang=js"

import "./InterestSelection.vue?vue&type=style&index=0&id=3b02eee0&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__